import { CircularProgress, Stack, Typography, Backdrop } from "@mui/material";
import React from "react";
import PropTypes from "prop-types";

const Loader = ({open}) => {
	return (
		<Backdrop
			sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
			open={true}
		>
			<Stack gap={1} justifyContent="center" alignItems="center">
				<CircularProgress  size={70} color="success" />
				<Typography>Loading...</Typography>
			</Stack>
		</Backdrop>
	);
};

Loader.propTypes = {
	open: PropTypes.bool
};

Loader.defaultProps = {
	open: false
};

export default Loader;
